import { TPrimitiveId } from "../Select/Select";

export type TValidator = (val:any) => string|null
export default class Validators {
    static Required<T extends TPrimitiveId>(field:string) {
        return (val:T|null|undefined) => (val===null || val===undefined || val==="") ? `${field} is required` : null
    }
    static Email(field:string="Email") {
        return (val:string|null|undefined) => !val ? `${field} is required` : /^[^\s\@]+@[^\@\.\s]+\.[^\@\s]+$/.test(val) ? null : `Invalid ${field}`
    }
    static PositiveNumber(field:string, requiredMsg?:string, positiveNumberMsg?:string) {
        return (val:string|null|undefined) => {
            if (!val) return requiredMsg ?? `${field} is required`
            const num = Number(val)
            if (num>0) return null
            else return positiveNumberMsg ?? `${field} must be a positive number`
        }
    }
    static NonZeroNumber(field:string, requiredMsg?:string, nonZeroMsg?:string) {
        return (val:string|null|undefined) => {
            if (!val) return requiredMsg ?? `${field} is required`
            const num = Number(val)
            if (num) return null
            else return nonZeroMsg ?? `${field} must be a non-zero number`
        }
    }
    static Number(field:string, requiredMsg?:string, notNumberMsg?:string) {
        return (val:string|null|undefined) => {
            if (!val) return requiredMsg ?? `${field} is required`
            const num = Number(val)
            if (isNaN(num)) return notNumberMsg ?? `${field} must be a non-zero number`
            else return null
        }
    }
}